export const getTypeFromDirectory = (code, docReferences) => {
    const type = docReferences.find((el) => el.code === code)?.name || '';
    return type;
};
